import type { UserCommunication } from '@this+that/models';

import { DraftSyncStatus } from '../../enums/draftSyncStatus';
import type { ComposeSnapshotIndexEntry } from '../../store/ComposeSnapshotIndex';
import { collectDraftIds } from '../../store/ComposeSnapshotIndex/selectors';

export const getDraftSyncStatus = (
  entry: ComposeSnapshotIndexEntry | undefined,
  userCommunication?: UserCommunication,
  isSyncing = false,
): DraftSyncStatus => {
  if (!entry) {
    return DraftSyncStatus.SYNCED;
  }
  if (isSyncing) {
    return DraftSyncStatus.SAVING;
  }
  const hasProviderDraft =
    entry.draftId !== undefined &&
    userCommunication !== undefined &&
    collectDraftIds(userCommunication).has(entry.draftId);
  return hasProviderDraft
    ? DraftSyncStatus.UNSYNCED_CHANGES
    : DraftSyncStatus.LOCAL_ONLY;
};
